import { render, staticRenderFns } from "./footerModelOne.vue?vue&type=template&id=4c3b1e02&"
import script from "./footerModelOne.vue?vue&type=script&lang=js&"
export * from "./footerModelOne.vue?vue&type=script&lang=js&"
import style0 from "./footerModelOne.vue?vue&type=style&index=0&id=4c3b1e02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports